// src/theme/atomic/lightBlue.ts
var lightBlue = {
  10: "#002130",
  20: "#004261",
  30: "#006796",
  40: "#008DCF",
  50: "#00AEFF",
  60: "#3DC2FF",
  70: "#70D2FF",
  80: "#A1E1FF",
  90: "#C4ECFE",
  95: "#E5F6FE",
  99: "#F7FDFF"
};
var lightBlue_default = lightBlue;

export { lightBlue_default as default };
